import { Controller } from "@hotwired/stimulus"

// IMPORTANT: use jquery notation for listeners for correct interaction with related js methods!

export default class extends Controller {
    connect() {
        window.freigabe_edit_on = false // flag

        document.addEventListener("click", call_freigabe_reset)

        this.bind(".freigabe-button", show_freigabe_elements)
        this.bind(".freigabe-alle", freigabe_alle)
        this.bind(".freigabe-keine", freigabe_keine)
        this.bind(".freigabe-markierung-entfernen", freigabe_markierung_entfernen)

        this.bind(".freigabe-speichern", () =>
            freigabe_speichern({
                path: "/person_survey_configurations/update_person_survey_invitations",
                custom_error_message: "Nicht alle Einladungen konnten geändert werden. Bitte versuchen Sie es nochmal, oder kontaktieren Sie den Seabird-Kundensupport, info@seabird.ch (Code 806a).",
                no_changes_message: 'Es sind keine geänderten Freigaben vorhanden. Markieren Sie gewünschte Änderungen bitte im Feld "Einladung: Neuer Status".'
            })
        )
    }

    disconnect() {
        document.removeEventListener("click", call_freigabe_reset)
    }

    bind(selector, fn) {
        document.querySelectorAll(selector).forEach(el => {
            $(el).off("click.freigabeStimulus")  ; // remove previous listener
            $(el).on("click.freigabeStimulus", function(e) {
                e.stopPropagation()
                fn(e)
            })
        })
    }
}